import SensorsOutlinedIcon from "@mui/icons-material/SensorsOutlined";
import Box from "@mui/material/Box";

import { TestIds } from "@storyboard/web-test-ids/testIds";
import type { DriverRow, TagDefinition } from "@/types/driver";
import AvailabilityTile from "./AvailabilityTile";
import { ContextSection } from "./ContextBlock";
import DriverActionsCallout from "./DriverActionsCallout";
import HandsFreeTile from "./HandsFreeTile";
import PersonalDeviceTile from "./PersonalDeviceTile";
import TagValuesTile from "./TagValuesTile";
import VolumeTile from "./VolumeTile";

/**
 * The Storyboard status section: any actions the driver owes, with what to tell them, then the driver's device and
 * availability as a tile grid, two to a row with a divider under each, and the tags across the foot.
 */
export default function StatusBlock({ driver, tags }: { driver: DriverRow; tags: readonly TagDefinition[] }) {
  return (
    <ContextSection
      icon={<SensorsOutlinedIcon sx={{ fontSize: 18 }} />}
      title="Storyboard status"
      testId={TestIds.dispatch.contextStatus}
    >
      <DriverActionsCallout driver={driver} />
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          // The card's border closes the list; the last row's own divider would double it.
          "& > *:last-of-type, & > *:nth-last-of-type(2):nth-of-type(odd)": { borderBottom: "none" },
        }}
      >
        <PersonalDeviceTile driver={driver} />
        <AvailabilityTile driver={driver} />
        <HandsFreeTile driver={driver} />
        <VolumeTile driver={driver} />
        <TagValuesTile driver={driver} tags={tags} />
      </Box>
    </ContextSection>
  );
}
